import specialistImg from '@/modules/JobPointOfContact/assets/specialist-jessica-pearson.png';
import Image from 'next/image';

import styles from './JobContactGeneric.module.scss';

export const JobContactGeneric = () => {
  return (
    <div className={styles.jobContactGeneric}>
      <div className={styles.imageContainer}>
        <Image
          className={styles.image}
          src={specialistImg}
          priority={true}
          alt=""
          aria-hidden="true"
        />
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.textContainer}>
          <h2 className={styles.title}>Want to speak to someone about this role?</h2>
          <p className={styles.description}>Enquire to get connected to an expert recruiter.</p>
        </div>
      </div>
    </div>
  );
};
